import api from '../../api';

const path = '/sell/all/car';

export const getCarAllRequest = (id) => api.get(`${path}/get/${id}`);
export const getCarNoAccountRequest = (id) => api.get(`${path}/list/get/${id}`);
export const getCarAllListRequest = (params) =>
    api.get(`${path}/get`, { params });
export const getCarNoAccountListRequest = (params) =>
    api.get(`${path}/list/get`, { params });
export const getCarAllListCountRequest = () => api.get(`${path}/count`);
